import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const menuItemFn = /* @__PURE__ */ createRecipe('MenuItem', {}, [])

const menuItemVariantMap = {
  "interactive": [
    "false"
  ],
  "focused": [
    "true"
  ]
}

const menuItemVariantKeys = Object.keys(menuItemVariantMap)

export const menuItem = /* @__PURE__ */ Object.assign(memo(menuItemFn.recipeFn), {
  __recipe__: true,
  __name__: 'menuItem',
  __getCompoundVariantCss__: menuItemFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: menuItemVariantKeys,
  variantMap: menuItemVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, menuItemVariantKeys)
  },
  getVariantProps: menuItemFn.getVariantProps,
})